export default {
      id: "icon-profile-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "icons.svg#icon-profile",
      toString: function () {
        return this.url;
      }
    }